var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main",attrs:{"id":"imprint"}},[_c('div',{staticClass:"content"},[_c('Imprint'),_c('br'),_c('br'),_c('a',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("zurück")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }